var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image"},[_c('v-img',_vm._b({},'v-img',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }